export default "__VITE_ASSET__57bd2fc7__"